<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Isole e Olena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considerato uno dei primi dieci piccoli produttori di vino al mondo, Paolo de Marchi ne ha qualcosa
                        una reputazione. Nominato Signor Sangiovese dai pesi massimi del mondo enologico italiano, il suo piccolo
                        vigneto è una masterclass nel Chianti Classico. Crescendo anno dopo anno al di sopra del suo
                        concorrenti, voi de Marchi le nostre parole che vale la pena dare un'occhiata ai vini pregiati di Isole e Olena.
                    </div>

                    <div class="howto-title2">La burocrazia italiana vs il vino rosso italiano</div>
                    <div class="howto-text">
                        La reputazione stellare di Paolo è tanto più sorprendente in quanto il suo background non è toscano.
                        Proveniente dai Barolo del Piemonte, il padre di Paolo vide il potenziale del Chianti negli anni '50. COME
                        la fillossera fece sì che molti suoi contemporanei toscani si rivolgessero ad altre industrie, intraprendenti
                        Il signor de Marchi ha rubato le due minuscole frazioni di Isole e Olena per una canzone. Anni di
                        seguì la sperimentazione: nuovo nella regione e relativamente nuovo nella vinificazione in generale, Isole e
                        Olena ha impiegato alcuni anni prima di trovare i suoi piedi. La decisione del governo italiano di piantare a
                        Nemmeno l'enorme quantità di uva bianca ha aiutato, seguita dalla legge del 1967 che ha decretato tutto
                        I Chianti dovevano avere un po' di Trebbiano e Malvasia nella loro miscela. Tuttavia, questo era
                        revocato nel 2006, il che significa che le uve bianche non erano più consentite in una miscela di Chianti Classico. COME
                        Paolo scherzando diceva: “è molto più facile fare vini rossi con uve rosse”.
                    </div>

                    <div class="howto-title2">La nascita di Isole e Olena come supertuscan</div>
                    <div class="howto-text">
                        Ciò significava che de Marchi ha dovuto perfezionare la sua arte per tutti gli anni '80 con le uve Sangiovese. Il suo
                        primo blend puro (rilasciato nel 1980) è stato etichettato come IGT come burocrazia italiana ancora una volta
                        intervenuto e non avrebbe permesso ai vini del Chianti di essere etichettati come DOC (l'ironia è che DOC
                        lo status non era consentito a causa dell'inferiorità del vino, dovuta esclusivamente all'aggiunta
                        dell'uva bianca obbligatoria). Seguirono circa vent'anni di prove ed errori prima che colpisse
                        oro. Affinché un vino sia toscano, userebbe solo uve toscane e quindi i suoi tre vini di punta
                        Vin Santo, Chianti Classico e Cepparello sono 100% Sangiovese (la sua Collezione De Marchi all
                        presentano miscele di Syrah, Cabernet Sauvignon e Chardonnay).
                    </div>

                    <div class="howto-title2">Grande appeal internazionale</div>
                    <div class="howto-text">
                        I vini toscani dominano il commercio del fine wine italiano dal 2013 (crescita del 5,1% nel 2015 rispetto
                        0,9% nel 2010), e look ha continuato a farlo. Con l'abolizione della legge del 1967, aspettiamo di vedere
                        molti altri produttori supertuscan sul mercato. Per fortuna, non c'è snobismo del vino qui:
                        La produzione di 188.000 bottiglie di Isole e Olena viene esportata in almeno 26 paesi, il che significa che sia a Milano che a Melbourne procurarsi una bottiglia non dovrebbe essere troppo difficile.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Isole e Olena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Paolo de Marchi gilt als einer der zehn größten kleinen Weinproduzenten der Welt und hat einiges zu bieten
                        ein Ansehen. Von den Schwergewichten der italienischen Weinwelt „Herr Sangiovese“ genannt, sein Kleiner
                        Weinberg ist eine Meisterklasse im Chianti Classico. Steigt Jahr für Jahr weit über sein eigenes hinaus
                        Mitbewerber, Sie de Marchi unsere Worte, dass die edlen Weine von Isole e Olena einen Blick wert sind.
                    </div>

                    <div class="howto-title2">Italienische Bürokratie vs. italienischer Rotwein</div>
                    <div class="howto-text">
                        Paolos herausragender Ruf ist umso überraschender, als er keine toskanische Herkunft hat.
                        Paolos Vater stammte aus den Barolos des Piemont und erkannte in den 1950er Jahren das Potenzial des Chianti. Als
                        Die Reblaus veranlasste viele seiner toskanischen Zeitgenossen, sich unternehmerisch anderen Industrien zuzuwenden
                        Herr de Marchi schnappte sich die beiden kleinen Dörfer Isole und Olena für einen Song. Jahre von
                        Es folgten Experimente: Neu in der Region und relativ neu in der Weinherstellung im Allgemeinen, Isole e
                        Es dauerte ein paar Jahre, bis Olena Fuß fasste. Die Entscheidung der italienischen Regierung, a
                        Eine große Menge weißer Trauben half auch nicht, woraufhin das Gesetz von 1967 das alles vorsah
                        Chiantis mussten etwas Trebbiano und Malvasia in ihrer Mischung enthalten. Dies war jedoch der Fall
                        2006 widerrufen, was bedeutet, dass weiße Trauben in einer Chianti Classico-Mischung nicht mehr erlaubt sind. Als
                        Paolo sagte scherzhaft: „Es ist viel einfacher, Rotweine aus roten Trauben herzustellen.“
                    </div>

                    <div class="howto-title2">Die Geburt von Isole e Olena als Supertoskaner</div>
                    <div class="howto-text">
                        Dies bedeutete, dass de Marchi in den 80er Jahren seine Kunst mit Sangiovese-Trauben perfektionieren musste. Sein
                        Die erste reine Mischung (veröffentlicht 1980) wurde als italienische Bürokratie erneut als IGT bezeichnet
                        intervenierte und erlaubte nicht, Chianti-Weine als DOC zu kennzeichnen (die Ironie liegt darin, dass DOC
                        Der Status wurde aufgrund der Minderwertigkeit des Weins, die allein auf den Zusatz zurückzuführen war, nicht gewährt
                        der obligatorischen weißen Traube). Es folgten etwa zwanzig Jahre des Versuchs und Irrtums, bevor er zuschlug
                        Gold. Damit ein Wein toskanisch sei, würde er nur toskanische Trauben und damit seine drei Flaggschiffweine verwenden
                        Vin Santo, Chianti Classico und Cepparello sind 100 % Sangiovese (seine De Marchi Collection).
                        sind Mischungen aus Syrah, Cabernet Sauvignon und Chardonnay).
                    </div>

                    <div class="howto-title2">Große internationale Anziehungskraft</div>
                    <div class="howto-text">
                        Toskanische Weine dominieren seit 2013 den italienischen Weinhandel (5,1 % Wachstum im Jahr 2015 im Vergleich zu).
                        0,9 % im Jahr 2010) und es sieht so aus, als würde dies auch weiterhin so bleiben. Mit der Aufhebung des Gesetzes von 1967 erwarten wir etwas
                        viele weitere super toskanische Produzenten auf dem Markt. Zum Glück gibt es hier keinen Weinsnobismus:
                        Die Produktion von 188.000 Flaschen von Isole e Olena wird in mindestens 26 Länder exportiert, sodass es nicht allzu schwierig sein dürfte, eine Flasche zu ergattern, egal ob Sie in Mailand oder Melbourne sind.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Isole e Olena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considéré comme l'un des dix premiers petits producteurs de vin au monde, Paolo de Marchi a quelque chose de
                        une réputation. Nommé Mr Sangiovese par les poids lourds du monde viticole italien, son petit
                        vignoble est une masterclass dans le Chianti Classico. S'élevant année après année au-dessus de son
                        concurrents, vous de Marchi nos mots que les vins fins d'Isole e Olena valent bien le coup d'œil.
                    </div>

                    <div class="howto-title2">La bureaucratie italienne contre le vin rouge italien</div>
                    <div class="howto-text">
                        La réputation stellaire de Paolo est d'autant plus surprenante qu'il n'est pas d'origine toscane.
                        Originaire des Barolos du Piémont, le père de Paolo a vu le potentiel du Chianti dans les années 1950. Comme
                        le phylloxera poussa nombre de ses contemporains toscans à se tourner vers d'autres industries, entreprenants
                        M. de Marchi s'est emparé des deux petits hameaux d'Isole et d'Olena pour une chanson. Des années de
                        expérimentation suivie : nouveau dans la région et relativement nouveau dans la viticulture en général, Isole e
                        Olena a mis quelques années avant de trouver ses marques. La décision du gouvernement italien de planter un
                        quantité massive de raisins blancs n'a pas aidé non plus, suivi de la loi de 1967 décrétant que tous
                        Les Chiantis devaient avoir du Trebbiano et du Malvasia dans leur mélange. Cependant, cela a été
                        révoqué en 2006, ce qui signifie que les raisins blancs n'étaient plus autorisés dans un assemblage de Chianti Classico. Comme
                        Paolo a dit en plaisantant, "il est beaucoup plus facile de faire des vins rouges avec des raisins rouges".
                    </div>

                    <div class="howto-title2">La naissance d'Isole e Olena en tant que super-toscane</div>
                    <div class="howto-text">
                        Cela signifiait que de Marchi devait perfectionner son art tout au long des années 80 avec des raisins Sangiovese. Son
                        le premier mélange pur (sorti en 1980) a de nouveau été étiqueté IGT en tant que bureaucratie italienne
                        est intervenu et ne permettrait pas aux vins du Chianti d'être étiquetés comme DOC (l'ironie étant que DOC
                        le statut n'était pas autorisé en raison de l'infériorité du vin, qui était uniquement due à l'ajout
                        du cépage blanc obligatoire). Une vingtaine d'années d'essais et d'erreurs ont suivi avant qu'il ne frappe
                        or. Pour qu'un vin soit toscan, il n'utiliserait que des raisins toscans et donc ses trois vins phares
                        Vin Santo, Chianti Classico et Cepparello sont 100% Sangiovese (sa collection De Marchi tous
                        présentent des assemblages de Syrah, Cabernet Sauvignon et Chardonnay).
                    </div>

                    <div class="howto-title2">Énorme attrait international</div>
                    <div class="howto-text">
                        Les vins toscans dominent le commerce des vins fins italiens depuis 2013 (croissance de 5,1 % en 2015 par rapport à
                        0,9 % en 2010), et look a continué dans cette voie. Avec l'abrogation de la loi de 1967, on s'attend à voir
                        beaucoup plus de super producteurs toscans sur le marché. Heureusement, il n'y a pas de snobisme du vin ici:
                        La production de 188 000 bouteilles d'Isole e Olena est exportée dans au moins 26 pays, ce qui signifie que, que vous soyez à Milan ou à Melbourne, vous procurer une bouteille ne devrait pas être trop difficile.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Isole e Olena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considered one of the top ten small wine producers in the world Paolo de Marchi has something of
                        a reputation. Named Mr Sangiovese by the heavyweights of the Italian wine world, his little
                        vineyard is a masterclass in Chianti Classico. Rising year after year high above his
                        competitors, you de Marchi our words that Isole e Olena fine wines are well worth a look.
                    </div>

                    <div class="howto-title2">Italian red-tape vs Italian red wine</div>
                    <div class="howto-text">
                        Paolo’s stellar reputation is all the more surprising as his background is not a Tuscan one.
                        Hailing from the Barolos of Piedmont, Paolo’s father saw Chianti’s potential in the 1950s. As
                        phylloxera caused many of his Tuscan contemporaries to turn to other industries, enterprising
                        Mr. de Marchi snapped up the two tiny hamlets of Isole and Olena for a song. Years of
                        experimentation followed: new to the region and relatively new to winemaking in general, Isole e
                        Olena took a few years before it found its feet. The Italian government’s decision to plant a
                        massive amount of white grapes didn’t help either, followed by the 1967 law decreeing that all
                        Chiantis were required to have some Trebbiano and Malvasia in their blend. However, this was
                        revoked in 2006, meaning white grapes were no longer allowed in a Chianti Classico blend. As
                        Paolo jokingly said, “it’s much easier to make red wines using red grapes”.
                    </div>

                    <div class="howto-title2">The birth of Isole e Olena as a super-Tuscan</div>
                    <div class="howto-text">
                        This meant that de Marchi had to perfect his art throughout the 80s with Sangiovese grapes. His
                        first pure blend (released in 1980) was labelled as an IGT as Italian bureaucracy once again
                        intervened and would not permit Chianti wines to be labelled as DOC (the irony being that DOC
                        status was not allowed due to the inferiority of the wine, which was solely due to the addition
                        of the mandatory white grape). Twenty or so years of trial and error followed before he struck
                        gold. For a wine to be Tuscan, he would use only Tuscan grapes and thus his three flagship wines
                        Vin Santo, Chianti Classico and Cepparello are 100% Sangiovese (his De Marchi Collection all
                        feature blends of Syrah, Cabernet Sauvignon and Chardonnay).
                    </div>

                    <div class="howto-title2">Huge international appeal</div>
                    <div class="howto-text">
                        Tuscan wines have dominated Italian fine wine trade since 2013 (5.1% growth in 2015 compared to
                        0.9% in 2010), and look continued to do so. With the dismissal of the 1967 law, we expect to see
                        many more super Tuscan producers on the market. Thankfully, there is no wine snobbery here:
                        Isole e Olena's 188,000 bottle production is exported to at least 26 countries meaning that whether you’re in Milan or Melbourne getting hold of a bottle should not be too hard.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IsoleOlena",
    head: {
        title: 'Isole e Olena | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the renowned Isole e Olena wine producer in Tuscany, known for producing high-quality, expressive wines with a unique character. Savor the exceptional taste of Isole e Olena\'s world-class Chianti Classico, Cabernet Sauvignon, and Syrah. Experience the rich history and passion of Tuscany\'s winemaking heritage with every sip of Isole e Olena wine.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
